import React, { useState } from 'react';
import { Flex } from '@decisiv/ui-components';
import SearchInput from '@decisiv/ui-components/lib/components/SearchInput';

const DEALER_FIELD_OPTIONS = [
  { id: 'dealer_id', label: 'Dealer ID' },
  { id: 'dealer_name', label: 'Dealer Name' },
];

export const USER_FIELD_OPTIONS = [
  { id: 'user_id', label: 'User ID' },
  { id: 'user_email', label: 'User Email' },
];

// Full-page navigation on submit, same as PeriodSelector — no client-side
// fetch/state needed since the controller re-renders fresh props. Mirrors
// AdminFilters' field-selector SearchInput (e.g. the Users page).
const SearchBar = ({
  initialField = 'dealer_id',
  initialValue = '',
  onSearch,
  fieldOptions = DEALER_FIELD_OPTIONS,
}) => {
  const [searchField, setSearchField] = useState(initialField);
  const [searchText, setSearchText] = useState(initialValue);

  const handleSearchByChange = (fieldId) => {
    setSearchField(fieldId);
  };

  const handleSearch = (text) => {
    onSearch(searchField, text);
  };

  return (
    <Flex marginBottom={2}>
      <SearchInput
        size="small"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onSearch={handleSearch}
        searchOn="submit"
        searchByOptions={fieldOptions}
        searchByValue={searchField}
        onSearchByChange={handleSearchByChange}
      />
    </Flex>
  );
};

export default SearchBar;
